import { __assign } from "tslib";
import React, { useState, createContext, useContext } from 'react';
// ref: https://github.com/vercel/next.js/issues/43585
import { useRouter as useNextRouter } from 'next/compat/router';
import useCookies from './useCookies';
import useNavigation from './useNavigation';
import useLoading from './useLoading';
import { getParsedValue } from './utils/parser';
import { useNativeRouter } from './useNativeRouter';
var RouteContext = createContext({});
var Provider = RouteContext.Provider;
export var getParsedQuery = function (query, routeInfo) {
    var pathAliases = routeInfo.pathAliases, parser = routeInfo.parser;
    return Object.entries(query || {}).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var targetKey = pathAliases[key] || key;
        return __assign(__assign({}, acc), (_b = {}, _b[targetKey] = getParsedValue(targetKey, value, parser === null || parser === void 0 ? void 0 : parser.query), _b));
    }, {});
};
export var RouteProvider = function (_a) {
    var _b;
    var children = _a.children, ctx = _a.ctx, routeInfo = _a.routeInfo, useNativeMethods = _a.useNativeMethods;
    var id = routeInfo.id, name = routeInfo.name, parser = routeInfo.parser;
    var router = (useNativeMethods ? useNativeRouter(ctx) : useNextRouter());
    var _c = useLoading(), loading = _c.loading, dataLoading = _c.dataLoading, setDataLoading = _c.setDataLoading;
    var navigationUtils = useNavigation(router, parser === null || parser === void 0 ? void 0 : parser.query, routeInfo);
    var cookieUtils = useCookies(ctx, parser === null || parser === void 0 ? void 0 : parser.cookie);
    var _d = useState(cookieUtils.getCookies()), cookies = _d[0], setCookies = _d[1];
    var query = getParsedQuery(router.query, routeInfo);
    var headers = __assign(__assign({}, (_b = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _b === void 0 ? void 0 : _b.headers), { cookies: undefined });
    var setCookie = function (name, value, options) {
        cookieUtils.setCookie(name, value, options);
        setCookies(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
        });
    };
    var delCookie = function (name, options) {
        cookieUtils.delCookie(name, options);
        setCookies(function (prevState) {
            return Object.entries(prevState).reduce(function (cookieItems, _a) {
                var _b;
                var cookieName = _a[0], cookieValue = _a[1];
                return cookieName !== name
                    ? __assign(__assign({}, cookieItems), (_b = {}, _b[cookieName] = cookieValue, _b)) : cookieItems;
            }, {});
        });
    };
    var routeData = __assign(__assign(__assign({}, navigationUtils), cookieUtils), { dataLoading: dataLoading, setDataLoading: setDataLoading, loading: loading, events: router.events, beforePopState: router.beforePopState, delCookie: delCookie, setCookie: setCookie, id: id, name: name, cookies: cookies, headers: headers, query: query, asPath: router.asPath, pathName: router.pathname, pathAliases: routeInfo.pathAliases, pathPattern: routeInfo.pathPattern, parsers: parser, isReady: !!router.isReady });
    return React.createElement(Provider, { value: routeData }, children);
};
export var useRouter = function () { return useContext(RouteContext); };
//# sourceMappingURL=RouteProvider.js.map